import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Validation } from 'react-validation-decorator';
import Joi from 'joi';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment-timezone';
import TimezoneSearch from '../../../components/Timezone-Search/Timezone-Search';


class RescheduleConference extends Component {
  constructor(props) {
    super(props);
    console.log("RescheduleConference ->", props);
    this.state = {
      currentDateISO: props.currentDate,
      currentTimezone: props.currentTimezone,
      nextTimezone: null,
      nextDateISO:null,
      isError: true,
    };
    // this._handleInputChange = this._handleInputChange.bind(this);
    this._handleCloseRescheduleConferencePopup = this._handleCloseRescheduleConferencePopup.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired,
    _handleSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
  };

  // _handleInputChange(date) {
  //   this.setState({ nextDate: date }, () => {
  //     this.validate('nextDate');
  //   })
  // };

  validationSchema = Joi.object().keys({
    nextDateISO: Joi.date().timestamp('javascript').min('now').label('Reschedule On'),
    nextTimezone: Joi.string().required().label('timezone')
    // nextTimezone: Joi.object().keys({
    //   offset: Joi.string().required(),
    //   name: Joi.string().required(),
    //   abbr: Joi.string().required(),
    //   label: Joi.string().optional(),
    // }).label('timezone'),
  });

  _handleCloseRescheduleConferencePopup() {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  updateNextDate = () => {
    const { currentTimezone, currentDateISO, nextTimezone } = this.state;
    let nextDateISO = currentDateISO;
    if(nextTimezone){
      const oldDtTime = moment.tz(currentDateISO, currentTimezone).format("MM/DD/YYYY HH:mm");
      console.log({oldDtTime});
      nextDateISO = moment.tz(oldDtTime, "MM/DD/YYYY HH:mm", nextTimezone).format();
    }
    this.setState({nextDateISO })
  };

  render() {
    const { open, title, message } = this.props;
    const { currentTimezone, currentDateISO, nextTimezone, nextDateISO } = this.state;
    console.log({ currentTimezone, currentDateISO, nextTimezone, nextDateISO });
    return (
      <Modal show={open} onHide={this._handleCloseRescheduleConferencePopup}>
        <Modal.Header closeButton>
          <Modal.Title>{title || 'Reschedule Conference'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h4 className="mt0">{message || 'Are you sure you want to Reschedule Conference ?'} </h4> */}
          <form className="row" name="rescheduleConferenceForm" noValidate >
            {/*<div className="col-xs-12">*/}
              {/*{currentTimezone && currentTimezone.name &&*/}
                {/*<p>*/}
                  {/*<span>Currently Scheduled at: </span>*/}
                  {/*<span className="border-bottom ml5 mr5">{moment.tz(currentDateISO, currentTimezone).format('MMM Do, h:mm:ss A z')}</span>*/}
                {/*</p>}*/}
            {/*</div>*/}
            <div className="col-md-4">
              <h5>Reschedule On</h5>
              <DatePicker
                onChange={d => {
                  const currentDateISO = moment.tz(d.valueOf(), "Zulu" ).format();
                  this.setState({ currentDateISO}, ()=> this.updateNextDate());
                  // this._handleInputChange(currentDateISO.format('x'));
                }}
                selected={moment.tz(currentDateISO, currentTimezone)}
                minDate={moment()}
                todayButton={"Today"}
                showMonthDropdown
                showTimeSelect
                timeFormat="h:mm A"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="MM/DD/YY h:mm A"
                className="form-control"
              />
            {/*</div>*/}
            </div>
            <div className="col-md-8">
            {/*<div className={this.getValidationClassName('nextTimezone')} >*/}
              <h5>Timezone</h5>
              <TimezoneSearch dtz = {nextTimezone || currentTimezone}
                              _handleSelection={(timezone) => {
                                this.setState({ nextTimezone: timezone }, () => {
                                  this.updateNextDate();  // this.validate('timezone');
                                });
                              }}
              />
              {/*{this.renderValidationMessages('timezone')}*/}
            </div>
            {/*</div>*/}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button 
          bsStyle="success"
            // disabled={!!this.state.validation.errors.length || !this.state.nextDate}
            title={nextDateISO ? '' : 'Please select the date first'}
            onClick={() => this.props._handleSubmit(nextDateISO || currentDateISO, nextTimezone || currentTimezone)}
          >
            Confirm
          </Button>
          <Button
            bsStyle="default"
            onClick={this.props.onClose}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )
  };
}

export default RescheduleConference;
